module.exports = __webpack_public_path__ + "static/media/eat-explore-taskbar.cf491f95.png";